import { money } from "@/lib/totals";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const img = (kind, data) => `${API}/barcode/${kind}?data=${encodeURIComponent(data)}`;

const PRINT_CSS = `
  @page { size: 80mm auto; margin: 0; }
  * { font-family: 'Courier New', monospace; color: #000; }
  html, body { margin: 0; padding: 0; }
  body { width: 72mm; padding: 2mm; font-size: 11px; font-weight: bold; line-height: 1.25; }
  .c { text-align: center; }
  .r { text-align: right; }
  .b { font-weight: bold; }
  .lg { font-size: 15px; font-weight: bold; }
  .md { font-size: 13px; font-weight: bold; }
  .sep { border-top: 1px dashed #000; margin: 4px 0; }
  table { width: 100%; border-collapse: collapse; }
  td { font-size: 11px; font-weight: bold; vertical-align: top; }
  img { image-rendering: pixelated; }
`;

function openAndPrint(html) {
  const w = window.open("", "_blank", "height=800,width=400");
  if (!w) {
    alert("Please allow pop-ups for this site so receipts can print, then use 'Print Receipts' again.");
    return;
  }
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => {
    w.print();
    w.close();
  }, 500);
}

export function printReceipt(bill, customer, settings) {
  const s = settings || {};
  const dt = new Date(bill.created_at || Date.now()).toLocaleString("en-IN");
  const gstNo = s.gst_no || "";
  const qrData = `${bill.bill_number}|${bill.balance}|GST:${gstNo}`;

  const taxMap = {};
  const itemRows = bill.lines
    .map((l, i) => {
      const lt = Math.abs(l.line_total);
      const tax = Math.abs(l.tax_amount || 0);
      const net = lt;
      const half = +(tax / 2).toFixed(2);
      const rate = l.tax_rate || 0;
      if (!taxMap[rate]) taxMap[rate] = { cgst: 0, sgst: 0 };
      taxMap[rate].cgst += half;
      taxMap[rate].sgst += half;
      return `
      <tr><td colspan="4" class="b">${i + 1}. ${l.barcode}&nbsp;&nbsp;HSN:${l.hsn || "-"}</td></tr>
      <tr><td colspan="4">${l.item_alias}</td></tr>
      <tr>
        <td>${Math.abs(l.qty)} ${l.uom || "EA"}</td>
        <td class="r">G ${money(lt)}</td>
        <td class="r">D 0.00</td>
        <td class="r">${rate}%</td>
      </tr>
      <tr>
        <td colspan="2" class="r">SGST ${money(half)}</td>
        <td class="r">CGST ${money(half)}</td>
        <td class="r b">N ${money(net)}</td>
      </tr>`;
    })
    .join("");

  const taxRows = Object.keys(taxMap)
    .sort()
    .map(
      (rate) =>
        `<tr><td>${rate}%</td><td class="r">${money(taxMap[rate].cgst)}</td><td class="r">${money(
          taxMap[rate].sgst
        )}</td></tr>`
    )
    .join("");

  const pays = bill.payments
    .map(
      (p) => `<div>Amount Paid by ${p.method}: ${money(Math.abs(p.amount))}${p.reference ? " (" + p.reference + ")" : ""}</div>`
    )
    .join("");

  const html = `<!doctype html><html><head><title>${bill.bill_number}</title>
  <style>${PRINT_CSS}</style></head><body>
    <div class="c"><img src="${img("qr", qrData)}" width="110" height="110"/></div>
    <div class="c lg">${s.shop_name || "RETAIL LTD"}</div>
    ${s.address1 ? `<div class="c">${s.address1}</div>` : ""}
    ${s.address2 ? `<div class="c">${s.address2}</div>` : ""}
    ${s.address3 ? `<div class="c">${s.address3}</div>` : ""}
    ${gstNo ? `<div class="c">GST No: ${gstNo}</div>` : ""}
    ${s.cin_no ? `<div class="c">CIN No: ${s.cin_no}</div>` : ""}
    <div class="sep"></div>
    <div class="c md">${bill.is_return ? "CREDIT NOTE (RETURN)" : "TAX INVOICE"}</div>
    <div class="sep"></div>
    <div>Bill No: ${bill.bill_number}</div>
    <div>Counter: ${s.counter_no || "1"}&nbsp;&nbsp;Session: ${s.session_no || "1"}</div>
    <div>Date: ${dt}</div>
    <div>Cashier: ${bill.cashier || ""}</div>
    <div>Mobile/Code: ${bill.customer_phone || "9999999999"} / ${bill.customer_name || "NA"}</div>
    <div class="sep"></div>
    <table>${itemRows}</table>
    <div class="sep"></div>
    <table>
      <tr><td class="b">Total Qty</td><td class="r b">${Math.abs(bill.item_count)}</td></tr>
      <tr><td>Round off</td><td class="r">0.00</td></tr>
      <tr><td>Total Disc. Amt</td><td class="r">${money(Math.abs(bill.discount))}</td></tr>
      <tr><td>Total GST Amt</td><td class="r">${money(Math.abs(bill.tax_total))}</td></tr>
      <tr><td class="lg">NET AMOUNT DUE</td><td class="r lg">${money(Math.abs(bill.balance))}</td></tr>
    </table>
    <div class="sep"></div>
    <table>
      <tr><td class="b">Tax%</td><td class="r b">CGST</td><td class="r b">SGST</td></tr>
      ${taxRows}
    </table>
    <div class="sep"></div>
    ${pays}
    <div>Balance Paid: ${money(Math.abs(bill.change || 0))}</div>
    <div class="sep"></div>
    <div class="c b">THANK YOU, VISIT AGAIN</div>
    ${s.reg_office1 ? `<div class="c">${s.reg_office1}</div>` : ""}
    ${s.reg_office2 ? `<div class="c">${s.reg_office2}</div>` : ""}
    ${s.email ? `<div class="c">${s.email}</div>` : ""}
    <div class="sep"></div>
    <div class="c"><img src="${img("code128", bill.bill_number)}" width="230"/></div>
    <div class="c">SCAN THIS BARCODE AT GATE</div>
  </body></html>`;
  openAndPrint(html);
}

export function printInternalSlip(bill) {
  if (!bill) return;
  const rows = bill.lines
    .map((l) => `<tr><td>${Math.abs(l.qty)}</td><td class="r">${money(Math.abs(l.line_total))}</td></tr>`)
    .join("");
  const html = `<!doctype html><html><head><title>${bill.bill_number} INTERNAL</title>
  <style>${PRINT_CSS}</style></head><body>
    <div class="c lg">INTERNAL CHECK COPY</div>
    <div class="c">${bill.is_return ? "REFUND" : "SALE"}</div>
    <div class="sep"></div>
    <div>Bill No: ${bill.bill_number}</div>
    <div class="sep"></div>
    <table><tr><td class="b">Qty</td><td class="r b">Amount</td></tr>${rows}</table>
    <div class="sep"></div>
    <table>
      <tr><td class="lg">Total Qty</td><td class="r lg">${Math.abs(bill.item_count)}</td></tr>
      <tr><td class="lg">Total Amt</td><td class="r lg">${money(Math.abs(bill.balance))}</td></tr>
    </table>
    <div class="sep"></div>
    <div class="c">*** NOT A TAX INVOICE ***</div>
  </body></html>`;
  openAndPrint(html);
}

export function printZReport(z) {
  if (!z) return;
  const row = (k, v) => `<tr><td>${k}</td><td class="r">${money(v)}</td></tr>`;
  const html = `<!doctype html><html><head><title>Z-Report</title>
  <style>${PRINT_CSS}</style></head><body>
    <div class="c lg">RETAIL LTD</div>
    <div class="c">Z-REPORT / DAY CLOSE</div>
    <div class="c">Register ${z.store} · ${z.cashier}</div>
    <div class="c">${new Date(z.generated_at).toLocaleString("en-IN")}</div>
    <div class="sep"></div>
    <table>
      ${row("Cash", z.buckets.CASH)}
      ${row("Card", z.buckets.CARD)}
      ${row("UPI", z.buckets.UPI)}
      ${row("Credit", z.buckets.CREDIT)}
      ${row("Coupon/Gift", z.buckets.COUPON)}
    </table>
    <div class="sep"></div>
    <table>
      <tr><td>Sales</td><td class="r">${z.sale_count}</td></tr>
      <tr><td>Returns</td><td class="r">${z.return_count}</td></tr>
      ${row("Total Tax", z.total_tax)}
      ${row("Refunds", z.refund_total)}
      <tr><td class="lg">NET TOTAL</td><td class="r lg">${money(z.net_total)}</td></tr>
    </table>
    <div class="sep"></div>
    <div class="c">*** END OF REPORT ***</div>
  </body></html>`;
  openAndPrint(html);
}
